import axios, { AxiosInstance } from "axios";
import appsettings from '../configs/appsettings.json';
import storageService from "./storage.service";
import { ToastService } from "./toast.service";
import i18n from "../i18n";

let showError = true;
let alertSessionExpired = false;

const handleRequest = (requestType?: any) => {
  let request = axios.create(
    {
      baseURL: appsettings.API_URL,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
      }
    }
  );

  requestInterceptor(request);

  if (requestType !== "file") {
    responseInterceptor(request);
  }

  return request;
}

function handleAuth(config: any) {
  const authentication = storageService.getAccessToken();
  const user = storageService.getUser();

  if (!config.headers) {
    config.headers = {};
  }

  if (authentication != null) {
    config.headers.Authorization = `Bearer ${authentication}`;
  }

  if (user?.localeId != null) {
    config.headers["id_locale"] = String(user.localeId);
  }
}


function handleError(error: any) {
  if (error.response && error.response.status === 401) {
    if (alertSessionExpired === false) {
      alertSessionExpired = true;
      localStorage.clear();
      //Alert.error(dictionary?.expired_session_do_logon);
      setTimeout(() => {
        // history.push("/Login");
        window.location.reload();
        alertSessionExpired = false;
      }, 1000);
    }
  } else {
    if (showError) {
      showError = false;
      //Alert.error(dictionary?.unexpected_error_contact_administrator);
    }
    setTimeout(() => {
      showError = true;
    }, 3000);
  }
}

function handleMessage(resultMessage: any) {
  if (resultMessage.message) {
    resultMessage.message = resultMessage.message.replaceAll('P0001: ', '');
    const t = i18n.t;
    switch (resultMessage.type) {
      case 0:
      case "ERROR":
        ToastService.error(t(resultMessage.message));
        break;
      case 1:
      case "WARNING":
        ToastService.warn(t(resultMessage.message), null);
        break;
      case 2:
      case "INFO":
        ToastService.info(t(resultMessage.message), null);
        break;
      case 3:
      case "SUCCESS":
        ToastService.success(t(resultMessage.message));
        break;
      default:
        ToastService.info(t(resultMessage.message), null);
        break;
    }
  }
}

function handleResponse(response: any) {
  (response.data.messages || []).forEach((resultMessage: any) => {
    handleMessage(resultMessage);
  });

  if (response.data.redirectRoute) {
    setTimeout(() => {
      //history.push(response.data.RedirectRoute);
      window.location.reload();
    }, 3000);
  }
}

function requestInterceptor(request: AxiosInstance) {
  request.interceptors.request.use(
    (config: { headers: { authorization: string; }; }) => {
      handleAuth(config);
      return config;
    }
  );
}

function responseInterceptor(request: AxiosInstance) {
  request.interceptors.response.use(
    (response) => {
      handleResponse(response);
      return response.data;
    },
    (error) => {
      handleError(error);
      return Promise.reject(error);
    }
  );
}

export const HttpService = {
  handleRequest
}